/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cost_BasisInputs */

const en_cost_basis = /** @type {(inputs: Cost_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rough average prices of German supermarkets.`)
};

const de_cost_basis = /** @type {(inputs: Cost_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grobe Durchschnittspreise deutscher Supermärkte.`)
};

/**
* | output |
* | --- |
* | "Rough average prices of German supermarkets." |
*
* @param {Cost_BasisInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_basis = /** @type {((inputs?: Cost_BasisInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_BasisInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cost_basis(inputs)
	return en_cost_basis(inputs)
});